/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable i18next/no-literal-string */

export type ImageConstantType = string | { Light: string; Dark: string };

// Leaving the type off this object so that TypeScript
// screams if you use a key that doesn't exist.
export const ImageConstants = {
  /**
   * Non-themed images use getAssetPath()
   */
  MicrosoftLogo: 'microsoft_logo.svg',
  AppStore_Apple: 'AppStore_Apple.svg',
  AppStore_GooglePlay: 'AppStore_GooglePlay.svg',
  AppStore_Microsoft: 'AppStore_Microsoft.svg',
  ProtectionActiveBackground: 'protection_active_background.svg',
  NeedsAttentionBackground: 'needs_attention.svg',
  IllustrationBackground: 'illustration_background.svg',
  ITPSecure: 'ITP_Secure.svg',
  ITPAlertSmall: 'ITP_Alert_small.png',
  DefenderShield: 'defenderShield.png',
  DefenderShieldLarge: 'defenderShield256x256.png',
  DeviceImage_Desktop: 'DeviceImage_Desktop.svg',
  DeviceImage_Laptop: 'DeviceImage_Laptop.svg',
  DeviceImage_Mobile: 'DeviceImage_Mobile.svg',
  DeviceImage_Tablet: 'DeviceImage_Tablet.svg',
  DeviceImage_2Devices: 'DeviceImage_2Devices.svg',
  DeviceImage_3Devices: 'DeviceImage_3Devices.svg',
  M365Word: 'M365_Word.svg',
  M365Excel: 'M365_Excel.svg',
  M365PowerPoint: 'M365_PowerPoint.svg',
  M365Outlook: 'M365_Outlook.svg',
  M365OneDrive: 'M365_OneDrive.svg',
  LightBulb: 'LightBulb.svg',
  Copilot: 'copilot.svg',
  CopilotPreview: 'copilot_preview.svg',

  /**
   * Themed images use useAssetPath()/useAssetsPath()
   */
  ExperianLogo: {
    Light: 'experian-l-logo.svg',
    Dark: 'experian-d-logo.svg',
  },
  DeviceMobile: {
    Light: '0066-device-mobile-l-standard.svg',
    Dark: '0067-device-mobile-d-standard.svg',
  },
  DeviceTablet: {
    Light: '0068-device-tablet-l-standard.svg',
    Dark: '0069-device-tablet-d-standard.svg',
  },
  DeviceLaptop: {
    Light: '0070-device-laptop-l-standard.svg',
    Dark: '0071-device-laptop-d-standard.svg',
  },
  DeviceDesktop: {
    Light: '0072-device-desktop-l-standard.svg',
    Dark: '0073-device-desktop-d-standard.svg',
  },
  DeviceMultiple: {
    Light: '0074-device-multiple-l-standard.svg',
    Dark: '0075-device-multiple-d-standard.svg',
  },
  EmailCheck: {
    Light: '0600-email-check-l-standard.svg',
    Dark: '0601-email-check-d-standard.svg',
  },
  EmailDismissPng: {
    Light: '0602-email-dismiss-l-standard-384x384.png',
    Dark: '0603-email-dismiss-d-standard-384x384.png',
  },
  EmailShield: {
    Light: '0568-email-shield-l-standard.svg',
    Dark: '0569-email-shield-d-standard.svg',
  },
  EmailShieldPng: {
    Light: '0568-email-shield-l-standard-384x384.png',
    Dark: '0569-email-shield-d-standard-384x384.png',
  },
  WebPersonCheckmark: {
    Light: '0672-web-person-checkmark-l-standard.svg',
    Dark: '0673-web-person-checkmark-d-standard.svg',
  },
  PeopleHeart: {
    Light: '0454-people-heart-l-standard.svg',
    Dark: '0455-people-heart-d-standard.svg',
  },
  CheckmarkProgress: {
    Light: '0352-checkmark-progress-l-standard.svg',
    Dark: '0353-checkmark-progress-d-standard.svg',
  },
  ShieldCheckmark: {
    Light: '0056-shield-checkmark-l-standard.svg',
    Dark: '0057-shield-checkmark-d-standard.svg',
  },
  Warning: {
    Light: '0062-warning-l-standard.svg',
    Dark: '0063-warning-d-standard.svg',
  },
  WebWarning: {
    Light: '0614-web-warning-l-standard.svg',
    Dark: '0615-web-warning-d-standard.svg',
  },
  ExclamationMark: {
    Light: '0012-exclamation-mark-l-standard.svg',
    Dark: '0013-exclamation-mark-d-standard.svg',
  },
  DevicesProtected: {
    Light: '0620-device-shield-checkmark-l-standard.svg',
    Dark: '0621-device-shield-checkmark-d-standard.svg',
  },
  DevicesUnprotected: {
    Light: '0724-device-shield-dismiss-l-standard.svg',
    Dark: '0725-device-shield-dismiss-d-standard.svg',
  },
  ShieldPerson: {
    Light: '0060-shield-person-l-standard.svg',
    Dark: '0061-shield-person-d-standard.svg',
  },
  ShieldPersonCheckmark: {
    Light: '0628-shield-person-checkmark-l-standard.svg',
    Dark: '0629-shield-person-checkmark-d-standard.svg',
  },
  ShieldPersonDismiss: {
    Light: '0619-shield-person-dismiss-l-standard.svg',
    // Mirrors source numbering, which subtracts instead of adds:
    Dark: '0618-shield-person-dismiss-d-standard.svg',
  },
  ShieldPersonPlus: {
    Light: 'shield-person-plus-l-tile.svg',
    Dark: 'shield-person-plus-d-tile.svg',
  },
  Firework: {
    Light: '0376-firework-l-standard.svg',
    Dark: '0377-firework-d-standard.svg',
  },
  BellExclamationMark: {
    Light: '0378-bell-exclamation-mark-l-standard.svg',
    Dark: '0379-bell-exclamation-mark-d-standard.svg',
  },
  SearchExclamationMark: {
    Light: '0032-search-exclamation-mark-l-standard.svg',
    Dark: '0033-search-exclamation-mark-d-standard.svg',
  },
  ArrowProgress: {
    Light: '0102-arrow-progress-l-standard.svg',
    Dark: '0103-arrow-progress-d-standard.svg',
  },
  ClockProgress: {
    Light: '0436-clock-progress-l-standard.svg',
    Dark: '0437-clock-progress-d-standard.svg',
  },
  AppDismiss: {
    Light: '0096-app-dismiss-l-standard.svg',
    Dark: '0097-app-dismiss-d-standard.svg',
  },
  WebPersonDismiss: {
    Light: '0712-web-person-dismiss-l-standard.svg',
    Dark: '0713-web-person-dismiss-d-standard.svg',
  },
  DocumentBug: {
    Light: '0390-document-bug-l-standard.svg',
    Dark: '0391-document-bug-d-standard.svg',
  },
  CardDismiss_Hero: {
    // Used for the Dashboard HERO
    Light: '0722-card-dismiss-l-standard.svg',
    Dark: '0723-card-dismiss-d-standard.svg',
  },
  CardDismiss_Tile: {
    // Used for the Dashboard TILE
    Light: 'credit-card-dismiss-l-tile.svg',
    Dark: 'credit-card-dismiss-d-tile.svg',
  },
  CardPlus: {
    Light: 'credit-card-plus-blue-l-tile.svg',
    Dark: 'credit-card-plus-blue-d-tile.svg',
  },
  ScanPerson: {
    Light: '0480-scan-person-l-standard.svg',
    Dark: '0481-scan-person-d-standard.svg',
  },
  ShieldDismiss: {
    Light: '0058-shield-dismiss-l-standard.svg',
    Dark: '0059-shield-dismiss-d-standard.svg',
  },
  Trust: {
    Light: '0054-trust-l-standard.svg',
    Dark: '0055-trust-d-standard.svg',
  },
  DocumentCloud: {
    Light: '0554-document-cloud-l-standard.svg',
    Dark: '0555-document-cloud-d-standard.svg',
  },
  ChatDismiss: {
    Light: '0030-chat-dismiss-l-standard.svg',
    Dark: '0031-chat-dismiss-d-standard.svg',
  },
  Attach: {
    Light: '0564-attach-l-standard.svg',
    Dark: '0565-attach-d-standard.svg',
  },
  DeviceShield: {
    Light: '0392-device-shield-l-standard.svg',
    Dark: '0393-device-shield-d-standard.svg',
  },
  DeviceShieldPng: {
    Light: '0392-device-shield-l-standard-384x384.png',
    Dark: '0393-device-shield-d-standard-384x384.png',
  },
  CallHistory: {
    // aka "Phone Clock"
    Light: '0036-call-history-l-standard.svg',
    Dark: '0037-call-history-d-standard.svg',
  },
  CardCheckmark: {
    // used for Dashboard Tile Cards
    Light: '0720-card-checkmark-l-standard.svg',
    Dark: '0721-card-checkmark-d-standard.svg',
  },
  PersonLock: {
    Light: '0016-person-lock-l-standard.svg',
    Dark: '0017-person-lock-d-standard.svg',
  },
  FoodCake: {
    Light: '0586-food-cake-l-standard.svg',
    Dark: '0587-food-cake-d-standard.svg',
  },
  WifiDismiss: {
    Light: '0014-wifi-dismiss-l-standard.svg',
    Dark: '0015-wifi-dismiss-d-standard.svg',
  },
  ShieldProgress: {
    Light: '0088-shield-progress-l-standard.svg',
    Dark: '0089-shield-progress-d-standard.svg',
  },
  DocumentExclamationMark: {
    Light: '0796-document-exclamationmark-l-standard.svg',
    Dark: '0797-document-exclamationmark-d-standard.svg',
  },
  M365Icon_20Regular: {
    Light: '0000-icon-l-m365-20regular.svg',
    Dark: '0000-icon-d-m365-20regular.svg',
  },
  VPNCheckmark: {
    Light: 'vpn-checkmark-l.svg',
    Dark: 'vpn-checkmark-d.svg',
  },
};
